/* unplugin-vue-components disabled */import script from "./eliminated.vue?vue&type=script&lang=jsx"
export * from "./eliminated.vue?vue&type=script&lang=jsx"

import "./eliminated.vue?vue&type=style&index=0&id=0eca32ff&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eca32ff"]])

export default __exports__